import {any, propEq} from 'ramda'

export default any(propEq('isChanged', true))
